import { Divider, FormGroup, Stack } from '@mui/material';

import { CheckboxField } from '../checkbox-field';

export type CheckboxGroupField = {
  name: string;
  options: Array<{
    uuid: string;
    label: string;
  }>;
};

export const CheckboxGroupField = ({ name, options }: CheckboxGroupField) => {
  return (
    <FormGroup>
      <Stack divider={<Divider />}>
        {options.map(({ uuid, label }) => (
          <CheckboxField
            key={uuid}
            name={name}
            label={label}
            value={uuid}
            formControlLabelProps={{
              labelPlacement: 'start',
              sx: { justifyContent: 'space-between', ml: 0, minHeight: 56 },
            }}
          />
        ))}
      </Stack>
    </FormGroup>
  );
};
